import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Woordmerk } from './ui';

/* ==========================================================================
   Het gedeelde scherm voor inloggen, aanmelden en wachten op goedkeuring:
   links een diepgroen paneel met de merknaam, rechts het formulier.
   Onder lg valt het paneel weg en blijft alleen het formulier over.
   ========================================================================== */

export default function AuthOmhulsel({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-screen bg-white lg:grid-cols-2">
      {/*
        De foto vult het paneel; de donkere sluier eroverheen is er niet voor de
        sier maar voor het contrast — zonder die laag valt witte tekst weg in de
        lichte plekken van de tafel.
      */}
      <aside className="relative hidden flex-col justify-between overflow-hidden px-12 py-12 text-white lg:flex">
        <img
          src="/foto/inloggen.jpg"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div aria-hidden="true" className="absolute inset-0 bg-krijt-950/70" />
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-gradient-to-t from-krijt-950/90 via-transparent to-krijt-950/60"
        />

        <div className="relative">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-veld-300">
            Tafelvoetbal · kantoor
          </p>
          <Link to="/" className="mt-3 block">
            <Woordmerk maat="lg" />
          </Link>
        </div>

        <p className="relative font-display text-[26px] leading-snug text-white">
          Wie is er nou
          <br />
          écht de beste?
        </p>
      </aside>

      <main className="flex items-center justify-center px-5 py-12">
        <div className="w-full max-w-sm">
          <Link to="/" className="mb-8 block text-center lg:hidden">
            <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-veld-700">
              Tafelvoetbal · kantoor
            </span>
            <Woordmerk toon="licht" maat="lg" />
          </Link>
          {children}
        </div>
      </main>
    </div>
  );
}

/** Label met de sterretjes-conventie uit het ontwerp. */
export function Etiket({ tekst, verplicht }: { tekst: string; verplicht?: boolean }) {
  return (
    <span className="mb-1.5 block text-[13px] font-medium text-krijt-700">
      {tekst}
      {verplicht ? <span className="text-kritiek"> *</span> : null}
    </span>
  );
}
